module.exports = __webpack_public_path__ + "img/161.a91636c1.jpg";